import React from "react"
import PropTypes from "prop-types"
import { sanitizer } from "@commonUtils"
import ImageLoader from "@components/ImageLoader/ImageLoader"
import { getAssetPath } from "@commonUtils"

import css from "./FooterSection.scss"
const oneMgLogo = getAssetPath("svgs/icons/1mg_logo_header.svg")

const OurPoliciesAndSolution = ({ data }) => {
    return (
        <div className={`${css.linksInnerContainer}`}>
            <h4
                className="linkHeaderBold"
                dangerouslySetInnerHTML={{
                    __html: sanitizer(data.title),
                }}
            />
            <ul className={`${css.listContainer}`}>
                {data.list.map((ele) => {
                    return (
                        <li className={`linkTextNormal ${css.lists}`} key={ele.title}>
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                className="noLinkColor"
                                href={ele.redirectUrl}
                            >
                                {ele.title}
                            </a>
                        </li>
                    )
                })}
            </ul>
        </div>
    )
}

const ReliableSecureAffordable = ({ data }) => {
    return (
        <>
            <div className="flex">
                <img
                    width="24px"
                    height="24px"
                    className={css.iconsHeader}
                    src={data.icon.url}
                    alt={data.icon.alt}
                />
                <h4
                    className="footerTextBold"
                    dangerouslySetInnerHTML={{
                        __html: sanitizer(data.title),
                    }}
                />
            </div>
            <p
                className="linkTextNormal marginTop-8"
                dangerouslySetInnerHTML={{
                    __html: sanitizer(data.text),
                }}
            />
        </>
    )
}

const FooterSection = ({ data, bgImageAnimation, isAnimationTriggered }) => {
    return (
        <section className={`positionRelative ${css.footerMainContainer}`}>
            <picture>
                <img
                    width="100%"
                    height="100%"
                    className="object-cover positionAbsolute"
                    srcSet={bgImageAnimation.backgroundImage.url}
                    alt={bgImageAnimation.backgroundImage.alt}
                />
            </picture>
            <div
                className={`${css.fixedImage} positionAbsolute hideMweb opacity-none ${
                    isAnimationTriggered ? "slideUp" : ""
                } `}
            >
                <picture>
                    <img
                        className="width-100"
                        srcSet={bgImageAnimation.animationImage.url}
                        alt={bgImageAnimation.animationImage.alt}
                    />
                </picture>
            </div>
            <div className="container-fluid positionRelative flexColumn">
                <ImageLoader alt="logo" height="36px" width="124px" src={oneMgLogo} />
                <div className={`marginTop-24 flex ${css.footerContainer}`}>
                    <h3
                        className="footerTextBold"
                        dangerouslySetInnerHTML={{
                            __html: sanitizer(data.title),
                        }}
                    />
                    <div className={`flex col-20 ${css.linksContainer}`}>
                        <div className={`flex ${css.linksContainer}`}>
                            <OurPoliciesAndSolution data={data.ourPolicies} />
                            <OurPoliciesAndSolution data={data.ourSolution} />
                        </div>
                        <div className="hideMweb">
                            <div className={`${css.seperator} height-100`}></div>
                        </div>
                        <div className={`flex ${css.linksContainer}`}>
                            <div>
                                <ReliableSecureAffordable data={data.Reliable} />

                                <div className="marginTop-24">
                                    <ReliableSecureAffordable data={data.Secure} />
                                </div>
                            </div>
                            <div>
                                <ReliableSecureAffordable data={data.Affordable} />

                                <div className="marginTop-24">
                                    <h4
                                        className="footerTextBold"
                                        dangerouslySetInnerHTML={{
                                            __html: sanitizer(data.Connectwithus.title),
                                        }}
                                    />

                                    <ul className={`flex ${css.iconsContainer}`}>
                                        {data.Connectwithus.icons.map((ele) => {
                                            return (
                                                <a
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    href={ele.redirectUrl}
                                                    key={ele.url}
                                                >
                                                    <img
                                                        width="32px"
                                                        height="32px"
                                                        src={ele.url}
                                                        alt={ele.alt}
                                                    />
                                                </a>
                                            )
                                        })}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <p
                        className="linkTextNormal"
                        dangerouslySetInnerHTML={{
                            __html: sanitizer(data.Footer.title),
                        }}
                    />
                </div>
            </div>
        </section>
    )
}

FooterSection.propTypes = {
    data: PropTypes.shape({
        logo: PropTypes.shape({
            text: PropTypes.shape({
                url: PropTypes.string.isRequired,
                alt: PropTypes.string,
            }),
            url: PropTypes.string.isRequired,
        }),
        title: PropTypes.string.isRequired,
        ourPolicies: PropTypes.shape({
            title: PropTypes.string.isRequired,
            list: PropTypes.arrayOf(
                PropTypes.shape({
                    title: PropTypes.string.isRequired,
                    redirectUrl: PropTypes.string.isRequired,
                })
            ).isRequired,
        }),
        ourSolution: PropTypes.shape({
            title: PropTypes.string.isRequired,
            list: PropTypes.arrayOf(
                PropTypes.shape({
                    title: PropTypes.string.isRequired,
                    redirectUrl: PropTypes.string.isRequired,
                })
            ).isRequired,
        }),
        Reliable: PropTypes.shape({
            icon: PropTypes.shape({
                url: PropTypes.string.isRequired,
                alt: PropTypes.string,
            }),
            title: PropTypes.string.isRequired,
            text: PropTypes.string.isRequired,
        }),
        Secure: PropTypes.shape({
            icon: PropTypes.shape({
                url: PropTypes.string.isRequired,
                alt: PropTypes.string,
            }),
            title: PropTypes.string.isRequired,
            text: PropTypes.string.isRequired,
        }),
        Affordable: PropTypes.shape({
            icon: PropTypes.shape({
                url: PropTypes.string.isRequired,
                alt: PropTypes.string,
            }),
            title: PropTypes.string.isRequired,
            text: PropTypes.string.isRequired,
        }),
        Connectwithus: PropTypes.shape({
            title: PropTypes.string,
            icons: PropTypes.arrayOf(
                PropTypes.shape({
                    redirectUrl: PropTypes.string.isRequired,
                    url: PropTypes.string.isRequired,
                    alt: PropTypes.string,
                })
            ).isRequired,
        }),
        Footer: PropTypes.shape({
            title: PropTypes.string.isRequired,
        }),
    }).isRequired,
    bgImageAnimation: PropTypes.shape({
        animationImage: PropTypes.shape({
            url: PropTypes.string.isRequired,
            alt: PropTypes.string,
        }),
        backgroundImage: PropTypes.shape({
            url: PropTypes.string.isRequired,
            alt: PropTypes.string,
        }),
    }),
}

export default FooterSection
